import React, { useEffect, useState } from "react";
import MenuHeader from "./MenuHeader";
import Modal from 'react-modal';
import useApi from "../hooks/useApi";
import { formatDistanceToNow } from 'date-fns';
import NotificationService from "../services/notification.service";
import UserService from "../services/user.service";
import AsyncSelect from 'react-select/async';
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import ZoneService from "../services/zone.service";
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    boxshadow: '0 0 10px rgba(0, 0, 0, 0.5)',
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    height: '680px',
  },
};

const customSelectStyles = {
  control: (styles) => ({
    ...styles,
    width: '100%',
    height: '60px',
    padding: '0 15px',
    fontSize: '14px',
    lineHeight: '60px',
    color: '#393D44',
    border: '0',
    borderRadius: '20px',
    background: '#ffffff',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
};

const Notification = () => {
  Modal.setAppElement('#root');
  const { t } = useTranslation('notification');

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [notifications, setNotifications] = useState([]);
  const api = useApi();
  const [hasMore, setHasMore] = useState(true);
  const limit = 100; // Nombre de clients par page
  const [clients, setClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Page actuelle
  const [totalPages, setTotalPages] = useState(1);   // Total des pages
  const [suggestions, setSuggestions] = useState([]);
  const { auth, setAuth } = useAuth();
  const navigation = useNavigate();
  const [zones, setZones] = useState([]);

  const goBack = () => navigation(-1);
  const [formData, setFormData] = useState({
    group_user: "",
    civility: "",
    type: "admin",
    clients: [],
    message: "",
    titre: "",
    user_id: null,
    date: new Date().toISOString().split('T')[0]

  });

  const loadClientsOptions = async (inputValue, callback) => {
    try {
        if(!inputValue || inputValue.length < 3) {
            callback([]);
            return;
        }
        const response = await UserService.indexByRole(
            { with: 'primary_address', status: '!eq:BLOCKED', name: `contains:${inputValue}` },
            'ROLE_CLIENT',
            api
        );
        const mergedClients = [...clients];
    
        response.forEach(newClient => {
          if (!mergedClients.find(client => client.id === newClient.id)) {
            mergedClients.push(newClient);
          }
        });
        
        setClients(mergedClients);
        const options = response.map(customer => ({
            value: customer.id,
            label: `${customer.id} - ${customer.extra?.full_name}`
        }));
        callback(options);
    } catch (error) {
        console.error("Error loading customer options", error);
        callback([]);
    }
};

  const fetchZones = async () => {
    try {
      const response = await ZoneService.index({}, api); // Remplace par ton endpoint
      setZones(response);
    } catch (error) {
      console.error("Erreur lors du chargement des zones:", error);
    }
  };

  const markNotificationsAsRead = async () => {
    try {
      await NotificationService.markAllNotificationsAsRead(api);
      if(auth && auth.user && auth.notifications?.length)
      auth.user.notifications = auth?.user?.notifications.map((notification) => ({
        ...notification,
        is_read: true,
      }));
      setAuth((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          notifications: auth?.user?.notifications,
        },
      }));
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };

  useEffect(() => {
    markNotificationsAsRead();
  }, []);

  const handleDelete = async (e, id) => {
      e.stopPropagation(); // Prevent the click event from bubbling up to the parent
    
      // Show a confirmation dialog
      const confirmDelete = window.confirm("Are you sure you want to delete this notification?");
      if (!confirmDelete) {
        return; // Exit the function if the user cancels the deletion
      }
    
      try {
        await NotificationService.delete(id, api);
        setCurrentPage(1);
        fetchNotifications(true);
      } catch (error) {
        console.error("Erreur lors du chargement des notification:", error);
      }
    
      console.log(`Delete ${id}`);
    };
  const handleSubmit = async (e) => {

    e.preventDefault();


    try {
      

      const updatedFormData = {
        ...formData,
        date: new Date().toISOString().replace('T', ' ').substring(0, 19),
        type: "admin",
        user_id: formData.group_user == "allClients" || formData.group_user == "allFlypro" || formData.group_user == "groupClient" || formData.group_user == "groupflyPro" ? auth?.user?.id : formData.user_id
      };
      console.log(updatedFormData)
      await NotificationService.store(updatedFormData, api)
      fetchNotifications(true);
      closeModal();
    } catch (error) {
      console.error("Erreur lors du chargement des notification:", error);
      // 
    }
  };

  const TimeAgo = ({ date }) => {
    return (
      <span>
        {formatDistanceToNow(new Date(date), { addSuffix: true })}
      </span>
    );
  };

  const fetchNotifications = async (refresh = null) => {
    try {
      const response = await NotificationService.index({
        with: `type, user_id`,
        'type': `in:admin`, 'user_id': `${auth?.user?.id}`, 'page': `${refresh ? 1 : currentPage}`, 'per_page': 5, 'sort': '-id'
      }, api)


      setHasMore(response?.last_page > response?.current_page)
      refresh ?
        setNotifications(response.data)
        :
        setNotifications((prev) => {
          const newNotifications = response.data.filter(
            (newNotif) => !prev.some((existingNotif) => existingNotif.id === newNotif.id)
          );

          return [...prev, ...newNotifications];
        });
    } catch (error) {
      console.error("Erreur lors du chargement des notification:", error);

    }
  };
  const handleClientsChange = (selected) => {
    let newClients = [];
  
    if (selected) {
      if (Array.isArray(selected)) {
        // cas de sélection multiple
        newClients = selected.map((client) => client.value);
      } else {
        // cas de sélection unique
        newClients = [selected.value];
      }
    }
  
    setFormData((prev) => ({
      ...prev,
      clients: newClients,
      user_id:selected.value
    }));
  };
  

  useEffect(() => {

    fetchZones();
    fetchNotifications();
  }, [currentPage]);
  const handleChange = async (e) => {
    const { name, value } = e.target;
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedFormData);
  
    // Charger les clients selon le groupe sélectionné
    if (name === "group_user") {
      setFormData((prev) => ({
        ...prev,
        clients: [],
      }));

      const role = value === "oneSpecificClient" || value === "groupClient"
        ? "ROLE_CLIENT"
        : value === "oneSpecificFlyPRO" || value === "groupflyPro"
        ? "ROLE_FLYPRO"
        : null;
  
      if (role && role != "ROLE_CLIENT") {
        try {
          const response = await UserService.indexByRole(
            { with: 'primary_address', status: '!eq:BLOCKED' },
            role,
            api
          );
          setClients(response);
        } catch (error) {
          console.error('Erreur lors de la récupération des utilisateurs :', error);
        }
      } else {
        setClients([]);
      }
    }
  };
  

  const clientOptions = clients.map((client) => ({
    value: client.id,
    label: client.extra?.full_name,
  }));
  
  const selectedClients = clientOptions.filter((option) => formData.clients.includes(option.value));
  

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {

  }

  const loadMoreOnClick = () => {

    setCurrentPage((prev) => prev + 1);
  };

  function closeModal() {
    setFormData({
      group_user: "",
      civility: "",
      type: "admin",
      message: "",
      titre: "",
      zones: [],
      user_id: "",
      clients:[],
      date: new Date().toISOString().split('T')[0]

    })
    setIsOpen(false);
  }
  const handleZonesChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      zones: selected ? selected.map((zone) => zone.value) : [],
    }));
  };
  const zoneOptions = zones.map((zone) => ({
    value: zone.id,
    label: zone.name,
  }));
  const selectedZones = zoneOptions.filter((option) => formData.zones?.includes(option.value));
  return (
    <>
      <MenuHeader />
      <div className="notification-breadcumb">
        <div className="turn-back">
          <div className="frame">
            <div className="div" onClick={goBack} >{"<"} {t('navigation.back')}</div>
          </div>
        </div>
        <div className="container">
          <button className="btn-send-notif" onClick={openModal}>
            {t('navigation.sendNotification')}
          </button>
        </div>
      </div>
      <div className="container">
        {notifications?.map((notification, index) => (
          <div className="notification" key={index}>
            <div onClick={(e) => handleDelete(e,notification.id)} className="notification-close-btn">×</div>
            {notification?.user?.image &&
              <div className="profile-picture">
                <img src={notification?.user?.image} alt={t('avatar.alt')} className="avatar-img" />
              </div>
            }
            <div className="notification-card-column">
              <div className="notification-card-header">
                <div className="notification-card-title">
                  <div className="notification-card-title-text">{notification.titre}</div>
                </div>
                <div className="notification-card-time">
                  <div className="notification-card-title-time-text"><TimeAgo date={notification.date} /></div>
                </div>
              </div>
              <div className="notification-card-content-wrapper">
                <div className="notification-card-content">
                  <div className="notification-card-content-text">{notification.message}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
        {hasMore && (
          <div className="btn-bottom" style={{ width: '90%'}}>
            <button className="loading-more-btn btn btn-primary" onClick={loadMoreOnClick}>
              {t('list.loadMore')}
            </button>
          </div>
        )}

      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={t('modal.title')}
      >
        <button class="close-button" onClick={closeModal}>
          <span class="close-icon">✖</span>
        </button>

        <h2>{t('modal.title')}</h2>
        {/* <p>{t('modal.info')}</p> */}
        <div className="form-inscription">
          <form onSubmit={handleSubmit}>
            <div className="form-text">
              <label>{t('form.sendTo.label')}</label>
              <select name="group_user" onChange={handleChange} value={formData.group}>
                <option value="">{t('form.sendTo.placeholder')}</option>
                <option value="allFlypro">{t('form.sendTo.options.allFlypro')}</option>
                <option value="allClients">{t('form.sendTo.options.allClients')}</option>
                <option value="oneSpecificFlyPRO">{t('form.sendTo.options.oneSpecificFlyPRO')}</option>
                <option value="oneSpecificClient">{t('form.sendTo.options.oneSpecificClient')}</option>
                <option value="groupClient">{t('form.sendTo.options.groupClient')}</option>
                <option value="groupflyPro">{t('form.sendTo.options.groupflyPro')}</option>
                <option value="zone">{t('form.sendTo.options.zone')}</option>
              </select>
            </div>
            {(formData.group_user === "allClients") && (
              <div className="form-choix flex-start">
                <div className="form-radio">
                  <input type="radio" name="civility" value="mr" id="hommes" onChange={handleChange} />
                  <label htmlFor="hommes">{t('form.gender.male')}</label>
                </div>
                <div className="form-radio">
                  <input type="radio" name="civility" value="mrs" id="femmes" onChange={handleChange} />
                  <label htmlFor="femmes">{t('form.gender.female')}</label>
                </div>
              </div>
            )}
            {(formData.group_user === "oneSpecificFlyPRO" || formData.group_user === "groupflyPro") && (
              <div className="form-text">
                <label>{t('form.email.flypro')}</label>
                <Select
                  isMulti={formData.group_user === "groupflyPro"}
                  options={clientOptions}
                  value={selectedClients}
                  onChange={handleClientsChange}
                  styles={customSelectStyles}
                  placeholder={t('form.clients.placeholder')}
                />
              </div>
            )}
            {(formData.group_user === "oneSpecificClient" || formData.group_user === "groupClient") && (
              <div className="form-text">
                <label>{t('form.email.client')}</label>
                
                <AsyncSelect
                  cacheOptions
                  defaultOptions={clientOptions}
                  defaultInputValue={selectedClients.label || ''}
                  loadOptions={loadClientsOptions}
                  isMulti={formData.group_user === "groupClient"}
                  options={clientOptions}
                  value={selectedClients}
                  onChange={handleClientsChange}
                  styles={customSelectStyles}
                  placeholder={t('form.clients.placeholder')}
                />
              </div>
            )}
            
            {formData.group_user === "zone" && (
            <div className="form-text">
              <label>{t('form.zones.label')}</label>
              <Select
                isMulti
                options={zoneOptions}
                value={selectedZones}
                onChange={handleZonesChange}
                styles={customSelectStyles}
                placeholder={t('form.zones.placeholder')}
              />
            </div>
             )}

            <div className="form-text">
              <label>{t('form.title.label')}</label>
              <input type="text" name="titre" onChange={handleChange} value={formData.titre} />
            </div>
            <div className="form-text">
              <label>{t('form.message.label')}</label>
              <textarea
                className="formTextArea"
                name="message"
                onChange={handleChange}
                value={formData.message}
              />
            </div>
            <button type="submit" className="btn-submit">
              {t('form.submit')}
            </button>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default Notification;